import axios from "axios";

const emailUrl = process.env.REACT_APP_EMAIL_SERVICE_BASE_URL as string;
// const emailUrl = 'http://localhost:3300/send-email';

export const postEmail = async (reqBody: any) => {
    // console.log("req body hai", reqBody)
    const res = await axios.post(emailUrl+'/email/ProductIT', reqBody,
    {headers: { "Content-Type": "application/json" }})
        return res
};

export const postSurveySubmissionEmail = async (reqBody: any) => {
    const res = await axios.post(
        emailUrl + '/email/ProductIT/send-survey-submission-email',
        reqBody,
        { headers: { "Content-Type": "application/json" } }
    );
    return res;
};
